import { render, staticRenderFns } from "./RolePermission.vue?vue&type=template&id=193c4e68"
import script from "./RolePermission.vue?vue&type=script&lang=ts"
export * from "./RolePermission.vue?vue&type=script&lang=ts"
import style0 from "./RolePermission.vue?vue&type=style&index=0&id=193c4e68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports